/* eslint-disable react/no-danger */
import { useRouter } from '@application/utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { HiXMark } from 'react-icons/hi2';
import { Button, ToastTitle, ToastTopBar } from '..';
import * as Styled from './styled';
import type { UnfinishedApplicationProps } from './types';

export const UnfinishedApplication: FC<UnfinishedApplicationProps> = (props) => {
  const { breederId, userFirstName, onCloseClick, onGoToApplicationClick } = props;
  const { translatedRoute, translate } = useRouter();

  const toastTitle: string = useMemo(() => {
    let title = translate('common.modals.unfinishedApplication.title');
    if (!userFirstName) {
      title = title.charAt(0).toUpperCase() + title.slice(1);
    }
    const username = `${userFirstName ? `${userFirstName}, ` : ''}`;
    return `${username}${title}`;
  }, [translate, userFirstName]);

  return (
    <>
      <ToastTopBar type="info" />
      <Styled.Header>
        <ToastTitle fontSize={18}>{toastTitle}</ToastTitle>
        <HiXMark onClick={onCloseClick} />
      </Styled.Header>
      <p
        dangerouslySetInnerHTML={{
          __html: translate('common.modals.unfinishedApplication.content'),
        }}
      />
      <Styled.Link>
        <Button
          link={`${translatedRoute('application')}${breederId}`}
          onClick={onGoToApplicationClick}
        >
          {translate('common.buttons.finishApplication')}
          <FaChevronRight />
        </Button>
      </Styled.Link>
    </>
  );
};
